export default __webpack_public_path__ + "static/media/loader.844dd506.svg";